<div class="table-card experts-card">
  <div class="card-header">
    <h4 class="card-title">الخبراء الأكثر نشاطاً</h4>
    <a class="view-all" href="javascript:void(0)">عرض الكل</a>
  </div>

  <ul class="ranked-list">
    @for (expert of rows; track expert.name; let first = $first) {
      <li class="ranked-item">
        <span class="rank-badge">{{ expert.rank }}</span>

        <div class="ranked-item-body">
          <div class="ranked-item-header">
            <span class="name">{{ expert.name }}</span>
            <span class="metric">
              <span class="metric-value">{{ expert.answeredQuestions }}</span>
              إجابة
            </span>
          </div>
          <div class="progress-track">
            @if (first) {
              <div class="progress-fill"></div>
            }
          </div>
        </div>
      </li>
    }
  </ul>
</div>
